<template>
  <div class="action-mage content-430">
    <div class="tab-box">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="index === active ? 'tab-item-active' : ''"
        class="tab-item"
        @click="handleSwitchTab(index)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="tab-content">
      <div class="content-left" v-show="tabLeft.length > 1">
        <div
          v-for="(item, index) in tabLeft"
          :key="index"
          class="left-item"
          :class="tabLeftActive === index ? 'left-item-active' : ''"
          @click="handleChangeTabLeft(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="content-right">
        <SealShowAndUpload
          v-show="activeItem === '机构印章设置'"
          :actionType="`org`"
          :id="orgId"
        ></SealShowAndUpload>
      </div>
    </div>
  </div>
</template>
<script>
import CourseOthers from '../assets/components/CourseOthers.vue';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import SetSignLocation from '../assets/components/SetSignLocation.vue';
import SealShowAndUpload from '../assets/components/SealShowAndUpload.vue';

export default {
  components: {
    CourseOthers,
    SetSignLocation,
    SealShowAndUpload
  },
  data() {
    return {
      tabList: [
        {
          name: '印章设置',
          tabLeft: [
            {
              name: '机构印章设置'
            }
          ]
        },


      ],
      orgId: this.$route.query.orgId,
      active: 0,
      tabLeftActive: 0,
      schoolId: '',
      switchParentPhoneNumber: false, // 屏蔽家长手机号码
      switchCourseTeacher: false, // 屏蔽任教安排
      switchOriginalSchool: false, // 是否填写原所在学校
      switchPayWages: false, // 是否参与平台发放教师工资 1开放 0不开放
      switchSignPlace: false, // 是否开启教师位置打卡 1开启 0不开启
      teaSignDayScope: '-1',
      loadingSwitch: false,
      infoSwitchPayWages: ''
    };
  },
  computed: {
    tabLeft() {

      return this.tabList[this.active].tabLeft;
    },
    activeItem() {
      return this.tabList[this.active].tabLeft[this.tabLeftActive].name;
    }
  },
  created() {
    this.schoolId = this.$route.query.schoolId;
  },
  methods: {
    handleChangeSalary(status) {
      this.loadingSwitch = true;
      if (this.infoSwitchPayWages === '1' && status === false) {
        this.$nextTick(() => {
          this.switchPayWages = true;
        });
        this.$Message.error('改操作需要管理员确认，请联系管理员');
      }
      this.loadingSwitch = false;
    },
    handleSwitchTab(index) {
      this.active = index;
      this.tabLeftActive = 0;
    },
    handleChangeTabLeft(index) {
      this.tabLeftActive = index;
    },




  }
};
</script>
<style lang="scss" scoped>
.tab-box {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 8px 16px;
    border: 1px solid #ccc;
    font-size: 24px !important;
    line-height: 24px;
    border-radius: 4px 4px 0 0;
    margin-bottom: -1px;
    background: rgb(240, 244, 249);
    color: rgb(127, 127, 127);
    cursor: pointer;
  }
  .tab-item + .tab-item {
    margin-left: 8px;
  }
  .tab-item-active {
    color: #6149f1;
    border-bottom: 1px solid #fff;
    background: transparent;
  }
}
.tab-content {
  display: flex;
  margin-top: 25px;
  .content-left {
    width: 16%;
    box-sizing: border-box;
    border: 1px solid #ccc;
    height: 300px;
    .left-item {
      padding: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .left-item-active {
      color: #6149f1;
      background: #efecfd;
    }
  }
  .content-right {
    flex: 1;
    padding-left: 24px;
    .content-right-box {
      padding: 16px 0;
      p {
        margin-top: 16px;
      }
    }
  }
}
.tips {
  color: #999;
}
</style>
